// extracted by mini-css-extract-plugin
export var languageInfo = "Languages-module--languageInfo--EaXZI";
export var languagePercentsWrap = "Languages-module--languagePercentsWrap--accFo";
export var languagesWrap = "Languages-module--languagesWrap--5fMyT";